// Core imports
import * as React from 'react';

// Components imports
import SubcategoryFilter from 'src/model/subcategoryFilter.model';

// Style and misc imports
import './Filter.scss';
import Checkbox from 'src/components/common/Checkbox';

class Filter extends React.Component<IFilterProps, any> {
  /*
      handleClick
     */
  private handleClick = (event: any) => {
    event.preventDefault();
    if (this.props.active === true) {
      this.props.action(this.props.filter, 'remove');
    } else {
      this.props.action(this.props.filter, 'add');
    }
  };

  public render() {
    const { filter } = this.props;
    return (
      <li className="filter-check" onClick={this.handleClick}>
        <Checkbox
          name={filter.name}
          value={`check${name}`}
          checked={this.props.active}
          onChange={this.handleClick}
        />
      </li>
    );
  }
}

export default Filter;

interface IFilterProps {
  indexKey: number;
  active: boolean;
  action: any;
  filter: SubcategoryFilter;
}
